import React, { FC, memo, useMemo } from "react";

import { LinearGradient } from "../LinearGradient";
import { DEFAULT_HEXAGON_RADIUS, DEFAULT_HEXAGON_SIDE_WIDTH } from "../../constants";
import { getHexagonAttrs } from "./getHexagonAttrs";
import { useSvgDrawParams } from "../../hooks/useSvgDrawParams";
import { HexagonProps } from "./types";

export const Hexagon: FC<HexagonProps> = memo(
  ({ symbol, radius = DEFAULT_HEXAGON_RADIUS, sideWidth = DEFAULT_HEXAGON_SIDE_WIDTH, flatTop = false, ...props }) => {
    const { fillId, strokeId, fillColor, fillColors, strokeColor, strokeColors, strokeWidth } =
      useSvgDrawParams(symbol);

    const { width, height, viewBox, commands } = useMemo(
      () => getHexagonAttrs({ radius, sideWidth, flatTop }),
      [radius, sideWidth, flatTop],
    );

    return (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox={viewBox} width={width} height={height} {...props}>
        <path
          d={commands}
          fill={fillColors.length ? `url(#${fillId})` : fillColor}
          stroke={strokeColors.length ? `url(#${strokeId})` : strokeColor}
          strokeWidth={strokeWidth}
        />
        {!!fillColors.length && (
          <defs>
            {!!fillColors.length && <LinearGradient id={fillId} colors={fillColors} />}
            {!!strokeColors.length && <LinearGradient id={strokeId} colors={[...strokeColors].reverse()} />}
          </defs>
        )}
      </svg>
    );
  },
);
